module.exports = __webpack_public_path__ + "img/home-instructions-score.75716587.jpg";